
import { supabase } from '@/integrations/supabase/client';

export interface CleanInterviewRequest {
  id: string;
  question: string;
  context?: string;
  context_url?: string;
  request_link: string;
  status: string;
  expires_at?: string;
}

export class CleanRequestService {
  static async getByLink(requestLink: string): Promise<CleanInterviewRequest | null> {
    try {
      console.log('CleanRequestService: Starting lookup for request link:', requestLink);
      console.log('CleanRequestService: Request link type:', typeof requestLink);
      console.log('CleanRequestService: Request link length:', requestLink?.length);
      
      // Always resolve by secure RPC to prevent direct table reads
      const { data: rpcData, error: rpcError } = await supabase.rpc(
        'find_request_by_link',
        { search_link: requestLink.trim() }
      );

      const data = Array.isArray(rpcData) ? rpcData[0] : rpcData;
      const error = rpcError;

      if (error) {
        console.error('CleanRequestService: Database error:', error);
        return null;
      }

      if (!data) {
        console.log('CleanRequestService: No data found');
        return null;
      }

      console.log('CleanRequestService: Raw data from database:', data);
      console.log('CleanRequestService: Question value:', data.question);
      console.log('CleanRequestService: Question type:', typeof data.question);
      console.log('CleanRequestService: Question length:', data.question?.length);

      const result = {
        id: data.id,
        question: data.question || 'Please provide your expert analysis on this topic.',
        context: data.context || undefined,
        context_url: data.context_url || undefined,
        request_link: data.request_link,
        status: data.status,
        expires_at: data.expires_at || undefined
      };

      console.log('CleanRequestService: Returning processed result:', result);
      return result;
    } catch (error) {
      console.error('CleanRequestService: Unexpected error:', error);
      return null;
    }
  }
}
